import React from 'react';
import PropTypes from 'prop-types';
import Loader from '../icons/loader';
import MoengageHelper from '../../../helpers/moengage-helper';
import { connect } from 'react-redux';
import './apply-coupon.m.css';

const MICRO_APPLY_COUPON_HERE = 'Enter coupon code here';
const APPLY_COUPON_HERE = 'Enter coupon/referral code here';
const WRONG_COUPON_CODE = 'Coupon is invalid';
const SUBSCRIPTION_EXISTS = 'Referral code not applicable';

class ApplyCoupon extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      is_utm_source_20007: false,
      couponFromUrl: ''
    };
    this.applyCoupon = this.applyCoupon.bind(this);
    this.checkTheme = this.checkTheme.bind(this);
  }

  applyCoupon() {
    let { couponCode = '', selectedPlanId } = this.props;
    couponCode = couponCode.trim();
    if (selectedPlanId && couponCode) {
      this.props.disablePlanSelection && this.props.disablePlanSelection();
      this.props.setLoading(() => {
        this.props.disableProceedButton && this.props.disableProceedButton();
        global.AccessType &&
          (this.props.newSubscriptionFlow
            ? global.AccessType.validateVoucher({
                subscriptionPlanId: selectedPlanId,
                voucher: couponCode
              })
            : global.AccessType.validateCoupon({
                subscriptionPlanId: selectedPlanId,
                couponCode
              })
          )
            .then(response => {
              if (!response.valid) {
                this.props.setLoading(() => this.props.onChangeCouponInput(''), false);
                this.props.handleInvalidCoupon(response, couponCode);
                this.props.enablePlanSelection && this.props.enablePlanSelection();
                this.props.enableProceedButton && this.props.enableProceedButton();
                return;
              }
              this.props.setAppliedCoupon(response);
              global.Moengage && MoengageHelper.couponCodeApplied(response);
              global.Moengage && MoengageHelper.couponCodeAppliedStatus(response);
              this.props.setLoading(() => this.props.onChangeCouponInput(''), false);
              this.props.enablePlanSelection && this.props.enablePlanSelection();
              this.props.enableProceedButton && this.props.enableProceedButton();
            })
            .catch(() => {
              this.props.setLoading(() => this.props.onChangeCouponInput(''), false);
              this.props.enablePlanSelection && this.props.enablePlanSelection();
              this.props.enableProceedButton && this.props.enableProceedButton();
            });
      }, true);
    }
  }

  componentDidMount() {
    // A coupon/ referral code obtained from a deep link is presently the only scenario where props.couponCode is already available while mounting.
    // Auto apply coupons obtained from a deep link

    const urlParams = new URLSearchParams(window.location.search);
    if (
      urlParams.has('utm_source') &&
      parseInt(urlParams.get('utm_source')) === 20007 &&
      urlParams.has('coupon')
    ) {
      this.setState({ is_utm_source_20007: true, couponFromUrl: urlParams.get('coupon') });
    }

    if (this.props.couponCode) {
      if (!this.state.is_utm_source_20007) {
        this.applyCoupon();
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedPlanId !== this.props.selectedPlanId) {
      this.props.clearCoupon();
    }
  }

  checkTheme(theme) {
    if (theme === 'blue') {
      return 'blue-';
    } else if (theme === 'white') {
      return 'white-';
    } else {
      return '';
    }
  }
  render() {
    const { isLoading, invalid, couponCode, disable, subscriptionExist = false } = this.props;
    const inputStyle = !isLoading && invalid ? 'wrong_code' : 'apply_code';
    const placeholder = subscriptionExist
      ? SUBSCRIPTION_EXISTS
      : !isLoading && invalid
        ? WRONG_COUPON_CODE
        : this.props.theme === 'white'
          ? MICRO_APPLY_COUPON_HERE
          : APPLY_COUPON_HERE;
    const themePrefix = this.checkTheme(this.props.theme);
    const loaderColor = this.props.theme === 'blue' ? '#fff' : '#000';
    return (
      <div styleName={`${themePrefix}wrapper`}>
        <div styleName={`${themePrefix}coupon`}>
          <input
            type="text"
            placeholder={placeholder}
            name="coupon-code"
            value={couponCode}
            styleName={`${themePrefix}input-box ${inputStyle}`}
            onChange={e => this.props.onChangeCouponInput(e.target.value)}
          />
          <button
            styleName={`${themePrefix}apply-button`}
            data-testid="apply-coupon"
            onClick={this.applyCoupon}
            disabled={isLoading || disable}
          >
            {isLoading ? <Loader color={loaderColor} /> : 'Apply'}
          </button>
        </div>
      </div>
    );
  }
}

ApplyCoupon.propTypes = {
  selectedPlanId: PropTypes.number.isRequired,
  setAppliedCoupon: PropTypes.func.isRequired,
  theme: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  invalid: PropTypes.bool.isRequired,
  subscriptionExist: PropTypes.bool.isRequired,
  couponCode: PropTypes.string.isRequired,
  setLoading: PropTypes.func.isRequired,
  handleInvalidCoupon: PropTypes.func.isRequired,
  onChangeCouponInput: PropTypes.func.isRequired,
  disable: PropTypes.bool,
  disablePlanSelection: PropTypes.func,
  disableProceedButton: PropTypes.func,
  enablePlanSelection: PropTypes.func,
  enableProceedButton: PropTypes.func,
  newSubscriptionFlow: PropTypes.bool,
  clearCoupon: PropTypes.func
};

const mapStateToProps = state => {
  const featureConfig = state.qt.config.features;
  return {
    newSubscriptionFlow: featureConfig.subscription.voucherify_subscription_flow
  };
};
export default connect(
  mapStateToProps,
  {}
)(ApplyCoupon);
